import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgentGatewayGlyph = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 8",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 23",
				cx: 1.5625,
				cy: 1.5625,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 26",
				cx: 1.5625,
				cy: 12.5,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 29",
				cx: 1.5625,
				cy: 23.4375,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 24",
				cx: 12.5,
				cy: 1.5625,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 27",
				cx: 12.5,
				cy: 12.5,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 30",
				cx: 12.5,
				cy: 23.4375,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 25",
				cx: 23.4375,
				cy: 1.5625,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 28",
				cx: 23.4375,
				cy: 12.5,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 31",
				cx: 23.4375,
				cy: 23.4375,
				r: 1.5625,
				fill: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 9",
				d: "M1.5625 1.5625L23.0469 23.8281",
				stroke: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 10",
				d: "M1.17188 23.4375L23.4375 1.95312",
				stroke: "#FBFBFB"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 11",
				d: "M1.5625 12.5L12.5 1.95312L23.4375 12.5L12.5 23.4375L1.5625 12.5Z",
				stroke: "#FBFBFB"
			})
		]
	})
});
export default SvgAgentGatewayGlyph;
